<template>
  <v-app-bar app dark class="asta-nav">
    <v-btn
      rounded
      depressed
      class="asta-nav-user navy darken-1 white--text"
      @click="toggleDrawer"
    >
      <v-avatar class="asta-nav-user-avatar" size="28">
        <v-img v-if="user_pic" contain :src="user_pic"></v-img>
        <v-icon v-else small>account_circle</v-icon>
      </v-avatar>
      <span class="asta-nav-user-name">
        {{ user_displayName || user_uid }}
      </span>
      <v-icon class="asta-nav-user-chevron" small>expand_more</v-icon>
    </v-btn>

    <!-- <v-btn
      fab
      x-small
      text
      class="white--text ml-2"
      @click="promptSblocco"
      v-if="!premium && user_uid && asta_squadre[user_uid]"
    >
      <v-icon>workspace_premium</v-icon>
    </v-btn>
    <v-btn fab x-small text class="ml-2" v-else> </v-btn> -->

    <!-- <dialog-iframe url="https://www.google.com"></dialog-iframe>
    <v-btn fab x-small text class="ml-2" @click="test">test </v-btn> -->

    <div
      class="asta-nav-center d-flex flex-column align-center"
    >
      <div class="d-flex justify-center align-center">
        <semaforo v-if="!mode_assegna" mode="bar"></semaforo>
        <!-- <v-btn
          fab
          x-small
          depressed
          v-else
          class="navy darken-2 white--text ml-1 con-ombra"
          @click="promptDownloadRose"
          ><v-icon>download</v-icon>
        </v-btn> -->
      </div>
    </div>

    <secondary-toolbar class="asta-nav-secondary"></secondary-toolbar>

    <!-- help -->
    <!-- <v-btn
      fab
      x-small
      text
      class="white--text mr-2"
      @click="promptComeFunziona"
    >
      <v-icon>info</v-icon>
    </v-btn> -->
    <!-- <v-btn
      v-if="Config.STANDALONE && !asta_info.isMine"
      @click="addToMyAste"
      icon
      light
      depressed
    >
      <v-icon>book</v-icon>
    </v-btn> -->

    <!-- <v-dialog eager v-model="dialog" content-class="dialog__halfWidth">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" icon depressed small class="white--text">
          <v-icon>share</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title class=" headline" style="width: 100%">
          <span class="white--text">Condividi</span>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            class="white--text"
            light
            icon
            @click="dialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title> -->
    <!-- <v-card-text>
          Fai sapere subito ai tuoi amici che hai trovato questo fantastico tool
          per gestire le aste in tempo reale
          <social-sharing
            url="https://www.fantapazz.com/fantacalcio/tutorials/asta-live"
            inline-template
          >
            <v-row row wrap>
              <v-col xs12 text-center>
                <network network="facebook">
                  <v-btn text>
                    <v-icon left fa>facebook</v-icon>
                    Facebook
                  </v-btn>
                </network>
              </v-col>
              <v-col xs12 class="text-center">
                <network network="twitter">
                  <v-btn text>
                    <v-icon left fa>twitter</v-icon>
                    Twitter
                  </v-btn>
                </network>
              </v-col>
              <v-col xs12 class="text-center">
                <network network="googleplus">
                  <v-btn text>
                    <v-icon left fa>google-plus</v-icon>
                    Google +
                  </v-btn>
                </network>
              </v-col>
              <v-col xs12 class="text-center">
                <network network="whatsapp">
                  <v-btn text>
                    <v-icon left fa>whatsapp</v-icon>
                    Whatsapp
                  </v-btn>
                </network>
              </v-col>
            </v-row>
          </social-sharing>
        </v-card-text> -->
    <!-- </v-card>
    </v-dialog> -->
  </v-app-bar>
</template>

<script>
// require("font-awesome/css/font-awesome.css");
import db from "../js/db";
import mixins from "../js/mixins";
import SquadraCrediti from "./common/SquadraCrediti";
import Semaforo from "./common/Semaforo";
import SecondaryToolbar from "./common/SecondaryToolbar";
// import DialogIframe from "./common/DialogIframe";
import Constants from "../js/constants";
import Vuex from "vuex";

export default {
  name: "asta-nav",
  mixins: [mixins],
  components: {
    SquadraCrediti,
    Semaforo,
    SecondaryToolbar,
    // DialogIframe,
  },
  mounted() {
    console.log("--> AstaNav ready.");
    // db.on("campetto-rettangolare", () => {
    //   this.tavoloLayoutModel = Constants.TAVOLO_LAYOUT.GRIGLIA;
    // });
  },
  destroyed() {
    console.log("<-- AstaNav destroyed.");
  },
  data() {
    return {
      dialog: false,
    };
  },

  methods: {
    // test() {
    //   db.emit("show-dialog-iframe", "www.google.com");
    // },
    goHome: function () {
      this.$router.push("/");
    },
    promptImpostazioni() {
      db.emit("showImpostazioni");
    },
    promptSblocco() {
      db.emit("showSblocco");
    },
    promptComeFunziona() {
      db.emit("showComeFunziona");
    },
    toggleUseSound() {
      this.$store.dispatch("setUseSound", !this.useSound);
    },
    // showUserPanel: function () {
    //   Swal.fire({
    //     title: this.asta_squadre[this.user_uid].name,
    //     html:
    //       '<img class="picture" src="' +
    //       this.asta_squadre[this.user_uid].pic +
    //       '"/>',
    //   });
    // },
    callLoginPanel: function () {

      Swal.fire({
        title: "Ciao " + this.user_displayName,
        html: "Solo i presidenti delle squadre possono partecipare all'asta. I co-gestori e gli ospiti non possono parteciparvi ma possono seguirla.",
        icon: "warning",
        confirmButtonColor: "var(--v-primary-base)",
        cancelButtonColor: "var(--v-grey-base)",
      });
    },
    // addToMyAste() {
    //   db.addAsta();
    // },
    toggleDrawer() {
      db.emit("toggleDrawer");
    },
    sharePanel() {
      Swal.fire({
        title: "Condividi",
        html:
          '<social-sharing url="https://vuejs.org/" inline-template>\n' +
          "  <div>\n" +
          '      <network network="facebook">\n' +
          '        <i class="fa fa-facebook"></i> Facebook\n' +
          "      </network></div></social-sharing>",
      });
    },
  },
  computed: {
    ...Vuex.mapGetters([
      "useSound",
      "tavoloLayout",
      "tavoloSize",
      "squadreSize",
      "is_mobile",
      "user_displayName",
      "user_pic",
      "user_uid",
    ]),
    bgSpeedDial() {
      return this.is_mobile ? "navy darken-1" : "navy darken-2";
    },
    colorSpeedDial() {
      return this.is_mobile ? "white--text" : "white--text";
    },
    soundModel: {
      get() {
        return this.useSound;
      },
      set(value) {
        this.$store.dispatch("setUseSound", value);
      },
    },
    tavoloLayoutModel: {
      get() {
        return this.tavoloLayout;
      },
      set(value) {
        // check
        if (value == Constants.TAVOLO_LAYOUT.CERCHIO) {
          let nSquadre = _.size(this.asta_squadre);
          let limit = Constants.LIMIT_SQUADRE_LAYOUT_CERCHIO;
          if (nSquadre > limit) {
            Swal.fire({
              icon: "info",
              title: "Suggerimento",
              text:
                "In leghe con più di " +
                limit +
                ' squadre è preferibile la visualizzazione a "griglia" e non a "tavolo rotondo" per evitare sovrapposizioni',
              confirmButtonText: "Ok, ho capito",
            });
          }
        }
        this.$store.dispatch("setTavoloLayout", value);
        if (value == Constants.TAVOLO_LAYOUT.CERCHIO) {
          this.$store.dispatch("setSquadreSize", Constants.SQUADRE_SIZE.SMALL);
        }
      },
    },
    tavoloSizeModel: {
      get() {
        return this.tavoloSize;
      },
      set(value) {
        this.$store.dispatch("setTavoloSize", value);
      },
    },
    squadreSizeModel: {
      get() {
        return this.squadreSize;
      },
      set(value) {
        this.$store.dispatch("setSquadreSize", value);
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.asta-nav {
  background-color: var(--dark_topbar) !important;
  box-shadow: none !important; //0px 1px 0 0 #1f343f !important;
}
.asta-nav-user {
  min-width: 0 !important;
  max-width: 180px !important;
  padding: 0 8px !important;
  background: var(--v-navy-darken1) !important;
  background-color: var(--v-navy-darken1) !important;
  color: white !important;
  justify-content: flex-start;
  overflow: hidden;
  text-transform: none;
}
.asta-nav-user::v-deep .v-btn__content {
  min-width: 0;
  width: 100%;
  justify-content: flex-start;
}
.asta-nav-user:hover {
  background: var(--v-navy-base) !important;
}
.asta-nav-user-avatar {
  flex: 0 0 auto;
  margin-right: 6px;
}
.asta-nav-user-name {
  display: block;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.asta-nav-user-chevron {
  flex: 0 0 auto;
  margin-left: 4px;
}
.asta-nav-center {
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}
.asta-nav-secondary {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
}

@media (max-width: 600px) {
  .asta-nav-user {
    max-width: 104px !important;
    padding: 0 4px !important;
  }
}
</style>
